module.exports = __webpack_public_path__ + "assets/img/download.754f0e1f.svg";